import { Theme } from '@mui/material/styles'

type StyleObject = {
  [key: string]: string | number
}

export const belowDesktop = (theme: Theme, styles: StyleObject) => `
  ${theme.breakpoints.down('desktop')} {
    ${Object.entries(styles)
      .map(([key, value]) => `${key}: ${value};`)
      .join(' ')}
  }
`

export const mobile = (theme: Theme, styles: StyleObject) => `
  ${theme.breakpoints.down('tablet')} {
    ${Object.entries(styles)
      .map(([key, value]) => `${key}: ${value};`)
      .join(' ')}
  }
`
export const tablet = (theme: Theme, styles: StyleObject) => `
  ${theme.breakpoints.between('tablet', 'laptop')} {
    ${Object.entries(styles)
      .map(([key, value]) => `${key}: ${value};`)
      .join(' ')}
  }
`

export const mobileAndTablet = (theme: Theme, styles: StyleObject) => `
  ${theme.breakpoints.down('laptop')} {
    ${Object.entries(styles)
      .map(([key, value]) => `${key}: ${value};`)
      .join(' ')}
  }
`

export const laptopAndDesktop = (theme: Theme, styles: StyleObject) => `
  ${theme.breakpoints.up('laptop')} {
    ${Object.entries(styles)
      .map(([key, value]) => `${key}: ${value};`)
      .join(' ')}
  }
`
